import styled from 'styled-components';

export const UnderlineTabContainerStyled = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 0;
`;

export const UnderlineTabCellStyled = styled.li<{
  isActive: boolean;
  tabWidth?: string;
  tabContent?: string;
  marginValue?: string;
}>`
  display: flex;
  width: ${(props) => (props.tabWidth ? props.tabWidth : '')};
  justify-content: ${(props) => (props.tabContent ? props.tabContent : '')};
  position: relative;
  ${(props) => props.theme.fonts.smallSize};
  ${(props) => props.theme.fonts.header5LineHeight};
  margin-left: ${(props) => (props.marginValue ? props.marginValue : props.theme.spacing.spacing4)};
  margin-right: ${(props) => (props.marginValue ? props.marginValue : props.theme.spacing.spacing4)};
  padding-right: ${(props) => props.theme.spacing.spacing2};
  padding-left: ${(props) => props.theme.spacing.spacing2};
  color: ${(props) => props.theme.colors.gray500};
  ${(props) =>
    props.isActive &&
    `
    &:after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      right: 0;
      height: 4px;
      background-color: ${props.theme.colors.primary};
      border-radius: 20px 20px 0 0;
    }
    color: ${props.theme.colors.gray900};
  `}
  &:hover {
    cursor: pointer;
  }
`;

export const SharedPrefixSuffixStyled = styled.span`
  background-color: ${(props) => props.theme.colors.gray100};
  border-radius: 10px;
  padding-left: ${(props) => props.theme.spacing.spacing4};
  padding-right: ${(props) => props.theme.spacing.spacing4};
  ${(props) => props.theme.fonts.tinySize};
  ${(props) => props.theme.fonts.header5LineHeight};
`;

export const PrefixStyled = styled(SharedPrefixSuffixStyled)`
  margin-right: ${(props) => props.theme.spacing.spacing3};
`;
export const SuffixStyled = styled(SharedPrefixSuffixStyled)`
  margin-left: ${(props) => props.theme.spacing.spacing3};
`;
